// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wxV2O","right":"styles_right__2wsfN"};